import Vue from 'vue'
import Router from 'vue-router'
import Util from '../util'

//PAGES
import Login from '../pages/Login'
import Home from '../pages/Home'

//COMPONENTS
const Consulta = () => import('../components/Consulta')
const ConsultaPorCaja = () => import('../components/ConsultaPorCaja')

const ConsultaMedios = () => import('../components/ConsultaMedios')
const ConsultaPorCajaMedios = () => import('../components/ConsultaPorCajaMedios')

const ConsultaPlanos = () => import('../components/ConsultaPlanos')
const ConsultaPorCajaPlanos = () => import('../components/ConsultaPorCajaPlanos')

const ConsultaMuestras = () => import('../components/ConsultaMuestras')
const ConsultaPorCajaMuestras = () => import('../components/ConsultaPorCajaMuestras')

const Pedidos = () => import('../components/Pedidos')
const Perfil = () => import('../components/Perfil')
const Recojos = () => import('../components/NuevoRecojos')
const Digitalizacion = () => import('../components/Digitalizacion')
const CambiarClave = () => import('../components/CambiarClave')
const ReporteFiles = () => import('../components/ReporteFiles')
const ReportePedidos = () => import('../components/ReportePedidos')
const Inquiries = () => import('../components/Inquiries')
const ReporteRecojos = () => import('../components/ReporteRecojos')
const ReporteDigitalizacion = () => import('../components/ReporteDigitalizacion')

const PedidoMedios = () => import('../components/PedidoMedios')
const MediaPickupList = () => import('../components/media/pickup/MediaPickupList')
const MediaPickupRequest = () => import('../components/media/pickup/MediaPickupRequest')

const MediaIncomeList = () => import('../components/media/income/MediaIncomeList')

const PedidoPlanos = () => import('../components/PedidoPlanos')
const RecojoPlanos = () => import('../components/RecojoPlanos')
const BlueprintPickupList = () => import('../components/blueprint/pickup/BlueprintPickupList')
const BlueprintPickupRequest = () => import('../components/blueprint/pickup/BlueprintPickupRequest')

const PedidoMuestras = () => import('../components/PedidoMuestras')
const RecojoMuestras = () => import('../components/RecojoMuestras')
const SamplePickupList = () => import('../components/sample/pickup/SamplePickupList')
const SamplePickupRequest = () => import('../components/sample/pickup/SamplePickupRequest')

const ReportePedidosMedios = () => import('../components/reportes/medios/ReportePedidos')
const ReporteRecojosMedios = () => import('../components/reportes/medios/ReporteRecojos')
const ReporteCajasMedios = () => import('../components/reportes/medios/ReporteCajas')

const ReportePedidosPlanos = () => import('../components/reportes/planos/ReportePedidos')
const ReporteRecojosPlanos = () => import('../components/reportes/planos/ReporteRecojos')

const ReportePedidosMuestras = () => import('../components/reportes/muestras/ReportePedidos')
const ReporteRecojosMuestras = () => import('../components/reportes/muestras/ReporteRecojos')

const ConsultaMasivaPorCaja = () => import('../components/ConsultaMasivaPorCaja')
const ConsultaMasivaPorArchivo = () => import('../components/consulta/ConsultaMasivaPorArchivo')

// PICKUPS (MATERIALS)
const FirstPickupList = () => import('../components/pedido/FirstPickupList')
const FirstPickupRequest = () => import('../components/pedido/FirstPickupRequest')

const Low = () => import('../components/Low')
const DisposalList = () => import('../components/disposal/DisposalList.vue')
const DisposalRequest = () => import('../components/disposal/DisposalRequest.vue')

Vue.use(Router)

//REPORTES
import FilesByRegistrationDate from '../components/reportes/files/FilesByRegistrationDate'
import BoxesByMonth from '../components/reportes/files/BoxesByMonth'
import BoxesByMonthByArea from '../components/reportes/files/BoxesByMonthByArea'


import SolicitudMateriales from '../components/SolicitudMateriales'
import BandejaSocios from '../components/BandejaSocios'
import BandejaDigitalizacion from '../components/BandejaDigitalizacion'
import ReporteMateriales from '../components/reportes/materiales/ReporteMateriales'

import ConsultaMateriales from '../components/reportes/materiales/ConsultaMateriales'
import ConsultaMaterialesDigitalizacion from '../components/reportes/materiales/ConsultaMaterialesDigitalizacion'

import RecojoMateriales from '../components/RecojoMateriales'

import EstadoMateriales from '../components/reportes/materiales/EstadoMateriales'

import MainPedido from '../components/pedido/MainPedido.vue'
import ImportBd from '../components/pedido/ImportBd.vue'

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      // redirect: { name: 'home.perfil' },
      beforeEnter: (to, from, next) => {
        if (!Util.checkAuth()) {
          next({name: 'login'})
        }
        next()
      },
      children: [
        {
          path: 'consulta',
          name: 'home.consulta',
          component: Consulta
        },
        {
          path: 'consultaPorCaja',
          name: 'home.consultaPorCaja',
          component: ConsultaPorCaja
        },
        {
          path: 'consultaMasivaPorCaja',
          name: 'home.consultaMasivaPorCaja',
          component: ConsultaMasivaPorCaja
        },
        {
          path: 'consultaMasivaPorArchivo',
          name: 'home.consultaMasivaPorArchivo',
          component: ConsultaMasivaPorArchivo
        },
        {
          path: 'consulta-medios',
          name: 'home.consultaMedios',
          component: ConsultaMedios
        },
        {
          path: 'consultaPorCaja-medios',
          name: 'home.consultaPorCajaMedios',
          component: ConsultaPorCajaMedios
        },
        {
          path: 'pedidos',
          name: 'home.pedidos',
          component: Pedidos,
        },
        {
          path: 'perfil',
          name: 'home.perfil',
          component: Perfil,
        },
        {
          path: 'recojos',
          name: 'home.recojos',
          component: Recojos,
        },
        {
          path: 'digitalizacion',
          name: 'home.digitalizacion',
          component: Digitalizacion,
        },
        {
          path: 'inquiries',
          name: 'home.inquiries',
          component: Inquiries,
        },
        {
          path: 'low',
          name: 'home.low',
          component: Low,
        },
        {
          path: 'disposals',
          name: 'home.disposals',
          component: DisposalList,
        },
        {
          path: 'disposals/request',
          name: 'home.disposals.request',
          component: DisposalRequest,
        },
        {
          path: 'cambiar-clave',
          name: 'home.cambiar-clave',
          component: CambiarClave,
        },
        {
          path: 'reporte-files',
          name: 'home.reporte-files',
          component: ReporteFiles,
          children: [
            {
              path: 'files-by-registration',
              name: 'home.reporte-files.files-by-registration',
              component: FilesByRegistrationDate,
              meta: {isReport: true}
            },
            {
              path: 'boxes-by-month',
              name: 'home.reporte-files.boxes-by-month',
              component: BoxesByMonth,
              meta: {isReport: true}
            },
            {
              path: 'boxes-by-month-area',
              name: 'home.reporte-files.boxes-by-month-area',
              component: BoxesByMonthByArea,
              meta: {isReport: true}
            },
          ]
        },
        {
          path: 'reporte-pedidos',
          name: 'home.reporte-pedidos',
          component: ReportePedidos,
        },
        {
          path: 'reporte-recojos',
          name: 'home.reporte-recojos',
          component: ReporteRecojos,
        },
        {
          path: 'reporte-digitalizacion',
          name: 'home.reporte-digitalizacion',
          component: ReporteDigitalizacion,
        },
        {
          path: 'pedido-medios',
          name: 'home.pedido-medios',
          component: PedidoMedios,
        },
        {
          path: 'media/pickups/list',
          name: 'home.media.pickups.list',
          component: MediaPickupList,
        },
        {
          path: 'media/pickups/request',
          name: 'home.media.pickups.request',
          component: MediaPickupRequest,
        },
        {
          path: 'media/income/list',
          name: 'home.media.income.list',
          component: MediaIncomeList,
        },
        {
          path: 'reporte-pedidos-medios',
          name: 'home.reporte-pedidos-medios',
          component: ReportePedidosMedios,
        },
        {
          path: 'reporte-recojos-medios',
          name: 'home.reporte-recojos-medios',
          component: ReporteRecojosMedios,
        },
        {
          path: 'reporte-cajas-medios',
          name: 'home.reporte-cajas-medios',
          component: ReporteCajasMedios,
        },
        //RUTAS PARA PLANOS
        {
          path: 'consulta-planos',
          name: 'home.consultaPlanos',
          component: ConsultaPlanos,
        },
        {
          path: 'consultaPorCaja-planos',
          name: 'home.consultaPorCajaPlanos',
          component: ConsultaPorCajaPlanos
        },
        {
          path: 'pedido-planos',
          name: 'home.pedido-planos',
          component: PedidoPlanos,
        },
        {
          path: 'recojo-planos',
          name: 'home.recojo-planos',
          component: RecojoPlanos,
        },
        {
          path: 'blueprint/pickups/list',
          name: 'home.blueprint.pickups.list',
          component: BlueprintPickupList,
        },
        {
          path: 'blueprint/pickups/request',
          name: 'home.blueprint.pickups.request',
          component: BlueprintPickupRequest,
        },
        {
          path: 'reporte-pedidos-planos',
          name: 'home.reporte-pedidos-planos',
          component: ReportePedidosPlanos,
        },
        {
          path: 'reporte-recojos-planos',
          name: 'home.reporte-recojos-planos',
          component: ReporteRecojosPlanos,
        },
        //RUTAS PARA MUESTRAS
        {
          path: 'consulta-muestras',
          name: 'home.consultaMuestras',
          component: ConsultaMuestras
        },
        {
          path: 'consultaPorCaja-muestras',
          name: 'home.consultaPorCajaMuestras',
          component: ConsultaPorCajaMuestras
        },
        {
          path: 'pedido-muestras',
          name: 'home.pedido-muestras',
          component: PedidoMuestras,
        },
        {
          path: 'recojo-muestras',
          name: 'home.recojo-muestras',
          component: RecojoMuestras,
        },
        {
          path: 'sample/pickups/list',
          name: 'home.sample.pickups.list',
          component: SamplePickupList,
        },
        {
          path: 'sample/pickups/request',
          name: 'home.sample.pickups.request',
          component: SamplePickupRequest,
        },
        {
          path: 'reporte-pedidos-muestras',
          name: 'home.reporte-pedidos-muestras',
          component: ReportePedidosMuestras,
        },
        {
          path: 'reporte-recojos-muestras',
          name: 'home.reporte-recojos-muestras',
          component: ReporteRecojosMuestras,
        },
        {
          path: 'solicitud-materiales',
          name: 'home.solicitud-materiales',
          component: SolicitudMateriales,
        },

        {
          path: 'bandeja-socios',
          name: 'home.bandeja-socios',
          component: BandejaSocios,
        },

        {
          path: 'bandeja-digitalizacion',
          name: 'home.bandeja-digitalizacion',
          component: BandejaDigitalizacion,
        },

        {
          path: 'reporte-materiales',
          name: 'home.reporte-materiales',
          component: ReporteMateriales,
        },

        {
          path: 'consulta-materiales',
          name: 'home.consulta-materiales',
          component: ConsultaMateriales,
        },

        {
          path: 'consulta-materiales-digitalizacion',
          name: 'home.consulta-materiales-digitalizacion',
          component: ConsultaMaterialesDigitalizacion,
        },

        {
          path: 'recojo-materiales',
          name: 'home.recojo-materiales',
          component: RecojoMateriales,
        },

        {
          path: 'estado-materiales',
          name: 'home.estado-materiales',
          component: EstadoMateriales,
        },

        {
          path: 'main-pedido',
          name: 'home.main-pedido',
          component: MainPedido,
        },
        {
          path: 'materials/pickups/list',
          name: 'home.materials.pickups.list',
          component: FirstPickupList,
        },
        {
          path: 'materials/pickups/request',
          name: 'home.materials.pickups.request',
          component: FirstPickupRequest,
        },
        {
          path: 'import-bd',
          name: 'home.import-bd',
          component: ImportBd,
        }

      ],
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (Util.checkAuth()) {
          next("/consulta")
        } else
          next()
      },
    },

  ],
  linkActiveClass: "is-active"
})

router.beforeEach((to, from, next) => {
  if (!Util.checkAuth() && to.name === "") {
    next({name: 'login'})
    return
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js